import React from 'react';
import './programCard.css';

import {
    Row,
    Col,
    Button,
    Card,
    CardText,
    CardBody,
    CardTitle,
    CardSubtitle
   
  } from "reactstrap";

 
  import { Link } from "react-router-dom";

const ProgramCard = (props) => {

        return (
            <div>
            
            <Row>
                <Col
                sm={{ size: 10, offset: 1 }}
                className="margin-between-cards"
                >
                <Card className="program-card h-100 d-flex">
                    
                    <CardBody>

                    <Row>
                        <Col>
                        <CardTitle className="home-events-card-titles program-calendar">
                            <h3> {props.days}</h3>
                        
                        </CardTitle>
                        <CardSubtitle className="home-events-card-subtitles program-calendar">
                            <p>{props.time}</p>
                            
                        </CardSubtitle>
                        <CardText className="home-events-card-text program-calendar">
                            {props.exclude}
                        </CardText>
                        </Col>
                        <Col sm={{ size: 'auto' }} className='d-flex align-items-center justify-content-center mt-2'>
                            <Link to="/apply-now" >
                                <Button className="program-apply">Apply </Button>
                            
                            </Link>
                        </Col>
                    </Row>

                    
                    
                    </CardBody>
                </Card>
                </Col>
            </Row>
            </div>
        );
    
}

export default ProgramCard;